import './cyntexaAtKnowledge.scss';
import Header from '../../src-utilities/header';
import './../../src-utilities/footer';
import './../../src-utilities/country';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/all';
import JustValidate from '.././../../node_modules/just-validate';

// Header init
new Header();

gsap.registerPlugin(ScrollTrigger);

const animateOnScroll = ({ selector, from, to }) => {
	gsap.fromTo(selector, from, {
		...to,
		scrollTrigger: {
			trigger: '.hero-gallery-grid',
			start: 'top center',
			end: 'bottom bottom-=200px',
			scrub: true,
			invalidateOnRefresh: true,
			anticipatePin: 1,
			// markers: true,
		},
	});
};

let centerImageSection = document.querySelector(
	'.konwledge-hero-section-img-center',
);

gsap.matchMedia().add('(min-width:1300px)', () => {
	// Left top image animation
	animateOnScroll({
		selector: '.knowledge26-left-part-1',
		from: { left: '0%', top: '-5%', scale: 0.8 },
		to: { left: '-8%', top: '-10%', scale: 0.7, duration: 2 },
	});

	// Left Bottom image animation
	animateOnScroll({
		selector: '.knowledge26-left-part-2',
		from: { left: '0%', bottom: '-10%', scale: 0.8 },
		to: { left: '-8%', botton: '-14%', scale: 0.7, duration: 2 },
	});

	// Right image animation
	animateOnScroll({
		selector: '.knowledge26-right-part-1',
		from: { right: '0%', top: '-5%', scale: 0.8 },
		to: { right: '-8%', top: '-10%', scale: 0.7, duration: 2 },
	});

	// Right image bottom animation
	animateOnScroll({
		selector: '.knowledge26-right-part-2',
		from: { right: '0%', bottom: '-10%', scale: 0.8 },
		to: { right: '-8%', bottom: '-14%', scale: 0.7, duration: 2 },
	});

	// Video section animation
	animateOnScroll({
		selector: '.konwledge-hero-section-img-center img',
		from: {
			width: '70%',
			onStart: () => {
				centerImageSection.style.top = '15%';
			},
		},
		to: { width: '90%', duration: 2 },
	});
});

gsap.matchMedia().add('(min-width:1230px) and (max-width:1300px)', () => {
	// Left top image animation
	animateOnScroll({
		selector: '.knowledge26-left-part-1',
		from: { left: '0%', top: '-5%', scale: 0.8 },
		to: { left: '-5%', top: '-8%', scale: 0.6, duration: 2 },
	});

	// Left Bottom image animation
	animateOnScroll({
		selector: '.knowledge26-left-part-2',
		from: { left: '0%', bottom: '-10%', scale: 0.8 },
		to: { left: '-5%', botton: '-12%', scale: 0.6, duration: 2 },
	});

	// Right image animation
	animateOnScroll({
		selector: '.knowledge26-right-part-1',
		from: { right: '0%', top: '-5%', scale: 0.8 },
		to: { right: '-5%', top: '-8%', scale: 0.6, duration: 2 },
	});

	// Right image bottom animation
	animateOnScroll({
		selector: '.knowledge26-right-part-2',
		from: { right: '0%', bottom: '-10%', scale: 0.8 },
		to: { right: '-5%', bottom: '-12%', scale: 0.6, duration: 2 },
	});

	// Video section animation
	animateOnScroll({
		selector: '.konwledge-hero-section-img-center img',
		from: {
			width: '60%',
			onStart: () => {
				centerImageSection.style.top = '15%';
			},
		},
		to: { width: '80%', duration: 2 },
	});
});

gsap.matchMedia().add('(min-width:1150px) and (max-width:1230px)', () => {
	// Left top image animation
	animateOnScroll({
		selector: '.knowledge26-left-part-1',
		from: { left: '0%', top: '-5%', scale: 0.7 },
		to: { left: '-5%', top: '-8%', scale: 0.6, duration: 2 },
	});

	// Left Bottom image animation
	animateOnScroll({
		selector: '.knowledge26-left-part-2',
		from: { left: '0%', bottom: '-5%', scale: 0.7 },
		to: { left: '-5%', botton: '-6.5%', scale: 0.6, duration: 2 },
	});

	// Right image animation
	animateOnScroll({
		selector: '.knowledge26-right-part-1',
		from: { right: '0%', top: '-5%', scale: 0.7 },
		to: { right: '-5%', top: '-8%', scale: 0.6, duration: 2 },
	});

	// Right image bottom animation
	animateOnScroll({
		selector: '.knowledge26-right-part-2',
		from: { right: '0%', bottom: '-5%', scale: 0.7 },
		to: { right: '-5%', bottom: '-6.5%', scale: 0.6, duration: 2 },
	});

	// Video section animation
	animateOnScroll({
		selector: '.konwledge-hero-section-img-center img',
		from: {
			width: '55%',
			onStart: () => {
				centerImageSection.style.top = '15%';
			},
		},
		to: { width: '70%', duration: 2 },
	});
});

gsap.matchMedia().add('(min-width:1000px) and (max-width:1150px)', () => {
	// Left top image animation
	animateOnScroll({
		selector: '.knowledge26-left-part-1',
		from: { left: '0%', top: '-5%', scale: 0.6 },
		to: { left: '-9%', top: '-8%', scale: 0.5, duration: 2 },
	});

	// Left Bottom image animation
	animateOnScroll({
		selector: '.knowledge26-left-part-2',
		from: { left: '0%', bottom: '-5%', scale: 0.6 },
		to: { left: '-8%', botton: '-6.5%', scale: 0.5, duration: 2 },
	});

	// Right image animation
	animateOnScroll({
		selector: '.knowledge26-right-part-1',
		from: { right: '0%', top: '-5%', scale: 0.6 },
		to: { right: '-9%', top: '-8%', scale: 0.5, duration: 2 },
	});

	// Right image bottom animation
	animateOnScroll({
		selector: '.knowledge26-right-part-2',
		from: { right: '0%', bottom: '-5%', scale: 0.6 },
		to: { right: '-8%', bottom: '-6.5%', scale: 0.5, duration: 2 },
	});

	// Video section animation
	animateOnScroll({
		selector: '.konwledge-hero-section-img-center img',
		from: {
			width: '50%',
			onStart: () => {
				centerImageSection.style.top = '15%';
			},
		},
		to: { width: '70%', duration: 2 },
	});
});

gsap.matchMedia().add('(min-width:900px) and (max-width:1000px)', () => {
	// Left top image animation
	animateOnScroll({
		selector: '.knowledge26-left-part-1',
		from: { left: '-3%', top: '-5%', scale: 0.5 },
		to: { left: '-10%', top: '-8%', scale: 0.4, duration: 2 },
	});

	// Left Bottom image animation
	animateOnScroll({
		selector: '.knowledge26-left-part-2',
		from: { left: '0%', bottom: '-5%', scale: 0.5 },
		to: { left: '-8%', botton: '-6.5%', scale: 0.4, duration: 2 },
	});

	// Right image animation
	animateOnScroll({
		selector: '.knowledge26-right-part-1',
		from: { right: '-3%', top: '-5%', scale: 0.5 },
		to: { right: '-10%', top: '-8%', scale: 0.4, duration: 2 },
	});

	// Right image bottom animation
	animateOnScroll({
		selector: '.knowledge26-right-part-2',
		from: { right: '0%', bottom: '-5%', scale: 0.5 },
		to: { right: '-8%', bottom: '-6.5%', scale: 0.4, duration: 2 },
	});

	// Video section animation
	animateOnScroll({
		selector: '.konwledge-hero-section-img-center img',
		from: {
			width: '50%',
			onStart: () => {
				centerImageSection.style.top = '15%';
			},
		},
		to: { width: '70%', duration: 2 },
	});
});

gsap.matchMedia().add('(min-width:800px) and (max-width:900px)', () => {
	// Left top image animation
	animateOnScroll({
		selector: '.knowledge26-left-part-1',
		from: { left: '-8%', top: '-18%', scale: 0.5 },
		to: { left: '-12%', top: '-8%', scale: 0.4, duration: 2 },
	});

	// Left Bottom image animation
	animateOnScroll({
		selector: '.knowledge26-left-part-2',
		from: { left: '-8%', bottom: '-8%', scale: 0.5 },
		to: { left: '-12%', bottom: '-8%', scale: 0.4, duration: 2 },
	});

	// Right image animation
	animateOnScroll({
		selector: '.knowledge26-right-part-1',
		from: { right: '-8%', top: '-18%', scale: 0.5 },
		to: { right: '-12%', top: '-8%', scale: 0.4, duration: 2 },
	});

	// Right image bottom animation
	animateOnScroll({
		selector: '.knowledge26-right-part-2',
		from: { right: '-8%', bottom: '-8%', scale: 0.5 },
		to: { right: '-12%', bottom: '-8%', scale: 0.4, duration: 2 },
	});

	// Video section animation
	animateOnScroll({
		selector: '.konwledge-hero-section-img-center img',
		from: {
			width: '50%',
			onStart: () => {
				centerImageSection.style.top = '15%';
			},
		},
		to: { width: '65%', duration: 2 },
	});
});

// Reserve Popup
let reservePopUp = document.querySelector('.reserve-spot-popup-screen');
let reserveOpen = document.querySelectorAll('.reserve-open');
let reserveClose = document.querySelector('.reserve-close-btn');

reserveOpen.forEach((e) => {
	e.addEventListener('click', () => {
		reservePopUp.classList.add('open');
	});
});

window.addEventListener('keydown', (e) => {
	if (e.key === 'Escape') {
		reservePopUp.classList.remove('open');
	}
});

reserveClose.addEventListener('click', () => {
	reservePopUp.classList.remove('open');
});
// Reserve Popup

// region Form Popup JS Code
const validate_popup = new JustValidate('#knowledge-form');

validate_popup
	.addField('#reserve-fullname', [
		{
			rule: 'required',
		},
		{
			rule: 'minLength',
			value: 2,
		},
		{
			rule: 'customRegexp',
			value: /^(?=\S)([A-Za-z]+(?:\s+[A-Za-z]+){1,})$/,
			errorMessage: 'Enter Valid Full Name',
		},
	])
	.addField('#reserve-email', [
		{
			rule: 'required',
		},
		{
			rule: 'email',
		},
		{
			validator: (value) => {
				let emailRegex =
					/^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,7})+$/;
				return emailRegex.test(value);
			},
			errorMessage: 'Please Enter Valid Email Address',
		},
	])
	.addField('#reserve-company', [
		{
			rule: 'required',
		},
		{
			rule: 'minLength',
			value: 2,
		},
		{
			rule: 'customRegexp',
			value: /^(?=.*[a-zA-Z])[a-zA-Z0-9\-_.,;:?!(){}[\]<>@#$%^&*+=|\\\/\s]{1,120}$/,
			errorMessage: 'Enter Valid Company Name',
		},
	])
	.addField('#meetingPreference', [
		{
			rule: 'required',
		},
		{
			validator: (value) => {
				return value !== 'Select' && !!value;
			},
			errorMessage: 'Please select preference',
		},
	])
	.addField('#reserve-phonenumber', [
		{
			rule: 'minLength',
			value: 4,
		},
		{
			rule: 'maxLength',
			value: 15,
		},
		{
			rule: 'customRegexp',
			value: /^(?![-+])[0-9]+$/,
			errorMessage: 'Enter Valid Phone Number',
		},
	]);

let GoogleSendURL =
	'https://script.google.com/macros/s/AKfycbyML8OHUDSwwvY_QcBlZ2uHYN_rQIx_VlWZPLjpxoJ9dB8GQEr6J7U0D8kNzC3-p0nH/exec';

document
	.querySelector('#knowledge-form')
	.addEventListener('submit', async (event) => {
		event.preventDefault();
		if (validate_popup.isValid === false) {
			return false;
		}
		document.querySelector('.loading-div').classList.add('active');
		const form = document.getElementById('knowledge-form');
		const formData = new FormData(form);
		let fullName = formData.get('lfullname').split(' ');
		let firstName, lastName;
		[firstName, ...lastName] = fullName;
		lastName = lastName.join(' ');
		formData.set('lfirstname', firstName);
		formData.set('llastname', lastName);
		formData.append('sendurlvalue', window.location.href);
		formData.set('lsource', 'MEC-SNKnowledge2026');

		let myHeaders = new Headers();
		myHeaders.append('Content-Type', 'application/json');

		// Initiate the Sales IQ visitor data
		if (window.$zoho && window.$zoho.salesiq) {
			try {
				$zoho.salesiq.visitor.uniqueid();
				$zoho.salesiq.visitor.name(firstName + ' ' + lastName);
				$zoho.salesiq.visitor.email(formData.get('lemail'));
				console.log('SalesIQ Name/Email set');
			} catch (error) {
				console.warn('SalesIQ Error:', error);
			}
		}

		let raw = JSON.stringify({
			firstName: formData.get('lfirstname'),
			lastName: formData.get('llastname'),
			email: formData.get('lemail'),
			phone: formData.get('lphone'),
			company: formData.get('lcompany'),
			Meeting_Preference: formData.get('meetingPreference'),
			country: formData.get('lcountry'),
			leadSource: formData.get('lsource'),
			websiteVisitURL: window.location.href,
		});

		let requestOptions = {
			method: 'POST',
			headers: myHeaders,
			body: raw,
			redirect: 'follow',
		};

		const googleRequestOptions = {
			method: 'GET',
			redirect: 'follow',
		};
		let request = '?';
		[...formData].forEach(([key, value], index) => {
			request += `${index === 0 ? '' : '&'}${key + '=' + value}`;
		});

		// Request 1: Main Backend
		const backendRequest = fetch(
			'https://us-west1-zoho-crm-scripts.cloudfunctions.net/queueLeadHttp',
			requestOptions,
		);

		// Request 2: Update the Google Sheet Data
		const googleRequest = fetch(
			GoogleSendURL + request,
			googleRequestOptions,
		);

		// Waiting until these request get's completed
		try {
			await Promise.allSettled([backendRequest, googleRequest]);
		} catch (e) {
			console.error('API Error', e);
		}

		// Redirect
		window.location.href = 'https://cyntexa.com/success';
	});
// endregion  Form Popup JS Code

// region Footer Contact Form
const validate_footer = new JustValidate('#knowledge-contact-form');

validate_footer
	.addField('#knowledge-contact-fullname', [
		{
			rule: 'required',
		},
		{
			rule: 'minLength',
			value: 2,
		},
		{
			rule: 'customRegexp',
			value: /^(?=\S)([A-Za-z]+(?:\s+[A-Za-z]+){1,})$/,
			errorMessage: 'Enter Valid Full Name',
		},
	])
	.addField('#knowledge-contact-Email', [
		{
			rule: 'required',
		},
		{
			rule: 'email',
		},
		{
			validator: (value) => {
				let emailRegex =
					/^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,7})+$/;
				return emailRegex.test(value);
			},
			errorMessage: 'Please Enter Valid Email Address',
		},
	]);

document
	.querySelector('#knowledge-contact-form')
	.addEventListener('submit', async (event) => {
		event.preventDefault();
		if (validate_footer.isValid == false) {
			return false;
		}

		document.querySelector('.loading-div').classList.add('active');
		const form = document.getElementById('knowledge-contact-form');
		const formData = new FormData(form);
		let fullName = formData.get('lfullname').split(' ');
		let firstName, lastName;
		[firstName, ...lastName] = fullName;
		lastName = lastName.join(' ');
		formData.set('lfirstname', firstName);
		formData.set('llastname', lastName);
		formData.append('sendurlvalue', window.location.href);
		formData.set('lsource', 'MEC-SNKnowledge2026');

		let myHeaders = new Headers();
		myHeaders.append('Content-Type', 'application/json');

		// Initiate the Sales IQ visitor data
		if (window.$zoho && window.$zoho.salesiq) {
			try {
				$zoho.salesiq.visitor.uniqueid();
				$zoho.salesiq.visitor.name(firstName + ' ' + lastName);
				$zoho.salesiq.visitor.email(formData.get('lemail'));
				console.log('SalesIQ Name/Email set');
			} catch (error) {
				console.warn('SalesIQ Error:', error);
			}
		}

		let raw = JSON.stringify({
			firstName: formData.get('lfirstname'),
			lastName: formData.get('llastname'),
			email: formData.get('lemail'),
			leadSource: formData.get('lsource'),
			websiteVisitURL: window.location.href,
		});

		let requestOptions = {
			method: 'POST',
			headers: myHeaders,
			body: raw,
			redirect: 'follow',
		};

		const googleRequestOptions = {
			method: 'GET',
			redirect: 'follow',
		};
		let request = '?';
		[...formData].forEach(([key, value], index) => {
			request += `${index === 0 ? '' : '&'}${key + '=' + value}`;
		});

		// Request 1: Main Backend
		const backendRequest = fetch(
			'https://us-west1-zoho-crm-scripts.cloudfunctions.net/queueLeadHttp',
			requestOptions,
		);

		// Request 2: Update the Google Sheet Data
		const googleRequest = fetch(
			GoogleSendURL + request,
			googleRequestOptions,
		);

		// Waiting until these request get's completed
		try {
			await Promise.allSettled([backendRequest, googleRequest]);
		} catch (e) {
			console.error('API Error', e);
		}

		// Redirect
		window.location.href = 'https://cyntexa.com/success';
	});

// endregion Footer Contact Form

//footer contact form mobile
const validate_footer_mobile = new JustValidate(
	'#knowledge-contact-form-mobile',
);

validate_footer_mobile
	.addField('#knowledge-contact-fullname-mobile', [
		{
			rule: 'required',
		},
		{
			rule: 'minLength',
			value: 2,
		},
		{
			rule: 'customRegexp',
			value: /^(?=\S)([A-Za-z]+(?:\s+[A-Za-z]+){1,})$/,
			errorMessage: 'Enter Valid Full Name',
		},
	])
	.addField('#knowledge-contact-Email-mobile', [
		{
			rule: 'required',
		},
		{
			rule: 'email',
		},
		{
			validator: (value) => {
				let emailRegex =
					/^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,7})+$/;
				return emailRegex.test(value);
			},
			errorMessage: 'Please Enter Valid Email Address',
		},
	]);

document
	.querySelector('#knowledge-contact-form-mobile')
	.addEventListener('submit', async (event) => {
		event.preventDefault();
		if (validate_footer_mobile.isValid == false) {
			return false;
		}

		document.querySelector('.loading-div').classList.add('active');
		const form = document.getElementById('knowledge-contact-form-mobile');
		const formData = new FormData(form);
		let fullName = formData.get('lfullname').split(' ');
		let firstName, lastName;
		[firstName, ...lastName] = fullName;
		lastName = lastName.join(' ');
		formData.set('lfirstname', firstName);
		formData.set('llastname', lastName);
		formData.append('sendurlvalue', window.location.href);
		formData.set('lsource', 'MEC-SNKnowledge2026');

		let myHeaders = new Headers();
		myHeaders.append('Content-Type', 'application/json');

		// Initiate the Sales IQ visitor data
		if (window.$zoho && window.$zoho.salesiq) {
			try {
				$zoho.salesiq.visitor.uniqueid();
				$zoho.salesiq.visitor.name(firstName + ' ' + lastName);
				$zoho.salesiq.visitor.email(formData.get('lemail'));
				console.log('SalesIQ Name/Email set');
			} catch (error) {
				console.warn('SalesIQ Error:', error);
			}
		}

		let raw = JSON.stringify({
			firstName: formData.get('lfirstname'),
			lastName: formData.get('llastname'),
			email: formData.get('lemail'),
			leadSource: formData.get('lsource'),
			websiteVisitURL: window.location.href,
		});

		let requestOptions = {
			method: 'POST',
			headers: myHeaders,
			body: raw,
			redirect: 'follow',
		};

		const googleRequestOptions = {
			method: 'GET',
			redirect: 'follow',
		};
		let request = '?';
		[...formData].forEach(([key, value], index) => {
			request += `${index === 0 ? '' : '&'}${key + '=' + value}`;
		});

		// Request 1: Main Backend
		const backendRequest = fetch(
			'https://us-west1-zoho-crm-scripts.cloudfunctions.net/queueLeadHttp',
			requestOptions,
		);

		// Request 2: Update the Google Sheet Data
		const googleRequest = fetch(
			GoogleSendURL + request,
			googleRequestOptions,
		);

		// Waiting until these request get's completed
		try {
			await Promise.allSettled([backendRequest, googleRequest]);
		} catch (e) {
			console.error('API Error', e);
		}

		// Redirect
		window.location.href = 'https://cyntexa.com/success';
	});

//faq JS
const BindEvent = () => {
	let faq_question = document.getElementsByClassName('faq-question');
	let hiddenFaqs = document.querySelectorAll('.hidden-faq');
	let viewAllFaqBtn = document.querySelector('.faq-view-btn');

	for (let i = 0; i < faq_question.length; i++) {
		const question = faq_question[i];
		question.addEventListener('click', function (e) {
			let all_faq = document.getElementsByClassName('faq');
			let isopen =
				e.currentTarget.parentNode.classList.contains('active');
			for (let index = 0; index < all_faq.length; index++) {
				all_faq[index].classList.remove('active');
			}
			if (isopen == false) {
				e.currentTarget.parentNode.classList.add('active');
			}
		});
	}

	viewAllFaqBtn.addEventListener('click', () => {
		if (!viewAllFaqBtn.classList.contains('active')) {
			viewAllFaqBtn.textContent = 'View Less';
			viewAllFaqBtn.classList.add('active');
			hiddenFaqs.forEach((hiddenFaq) => {
				hiddenFaq.style.display = 'flex';
			});
		} else {
			viewAllFaqBtn.textContent = 'View All';
			viewAllFaqBtn.classList.remove('active');
			hiddenFaqs.forEach((hiddenFaq) => {
				hiddenFaq.style.display = 'none';
			});
		}
	});
};

BindEvent();
//faq JS
